<!--
Author: erba-28
Create Time: 2019-06-28 16:40:37
Description:
-->
<template>
  <div class="com--data-import-previewer">
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      :fullscreen="true"

      v-loading="isLoading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      append-to-body
    >
      <el-tabs v-model="activeFileName" @tab-click="handleTabClick4File">
        <el-tab-pane
          v-for="(res, fileName) in resMap"
          :key="fileName"
          data-ignore-label="fileName"
          :name="fileName"
        >
          <span slot="label">
            <el-badge
              :is-dot="hasErrorMessage4File(res)"
              style="margin-top: 10px; margin-right: 40px;"
            >{{fileName}}</el-badge>
          </span>
          <div class="previewer-message">{{ (hasErrorMessage4File(res) && res.response && res.response.message) || ''}}</div>
          <el-tabs v-model="activeSheetName">
            <el-tab-pane
              v-for="(sheet, sheetName) in getSheetsMap4Res(res)"
              :key="sheetName"
              :label="sheetName"
              :name="sheetName"
            >
              <el-table :data="sheet.rows" border style="width: 100%" max-height="440">
                <el-table-column type="index" :index="indexMethod"></el-table-column>
                <el-table-column
                  v-for="(fieldCode, fieldName) in sheet.metadata.fieldsMap"
                  :key="fieldCode"
                  :prop="fieldCode"
                  :label="`${fieldName}${sheet.metadata.requiredFieldsList.indexOf(fieldName) > -1 ? '*' : ''}`"
                ></el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-tab-pane>
      </el-tabs>
      <el-upload
        ref="uploader"
        class="com--data-import-previewer-upload"
        :action="preUploadUrl"
        multiple
        data-ignore-limit="1"
        data-ignore-on-exceed="handleExceed"
        :file-list="fileList"
        :show-file-list="false"
        data-ignore-accept="importExcelAcceptTypes"
        data-ignore-before-upload="beforeImportExcel"
        :on-success="handleSuccess"
        :on-error="handleError"
        :auto-upload="false"
        :headers="headers"
      >
        <!-- <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传excel文件</div>-->
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel4Dialog">取 消</el-button>
        <el-button type="primary" @click="handleConfirm4Dialog">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DataImportPreviewer',
  props: {
    preUploadUrl: String
  },
  data () {
    return {
      graphImgUploadHeaders: { Authorization: '' },
      dialogVisible: false,

      // pre-upload
      fileList: [],

      // tabs
      activeFileName: '',
      activeSheetName: '',
      // sheetsMapList: [],

      resMap: {},
      promiseCb: {
        resolve: () => Promise.resolve(),
        reject: () => Promise.reject(new Error('noop'))
      },

      isLoading: false
    }
  },
  computed: {

    headers(){
            return{
                "Authorization":sessionStorage.getItem("Token")
            }
        }
  },
    activated() {
                  this.graphImgUploadHeaders.Authorization = sessionStorage.getItem('Token');
                },
  methods: {
    preview (fileList) {
      const vm = this
      vm.dialogVisible = true

      vm.fileList.splice(
        0,
        vm.fileList.length,
        ...vm.makeFileListReady(
          // 过滤出待上传的
          fileList.filter(item => item.status === 'ready')
        )
      )

      vm.$set(vm, 'resMap', {})

      if (vm.fileList.length === 0) {
        vm.$message({
          type: 'warning',
          message: '请选择待上传文件 '
        })
        return Promise.reject(new Error('no files to pre-upload'))
      }

      return new Promise((resolve, reject) => {
        vm.$set(vm, 'promiseCb', {
          resolve,
          reject
        })
        vm.$nextTick(() => {
          vm.isLoading = true
          vm.$refs['uploader'].submit()
        })
      })
    },
    upload4Preview (fileList) {
      const vm = this

      vm.fileList.splice(0, vm.fileList.length, ...fileList)
    },
    handleSuccess (response, file, fileList) {
      const vm = this
      vm.$set(vm.resMap, file.name, {
        error: false,
        response
      })

      fileList.splice(fileList.indexOf(file), 1)
      if (fileList.length === 0) {
        vm.showPreviewRes4FileList()
      }


    },
    handleError (err, file, fileList) {
      const vm = this
      vm.$set(vm.resMap, file.name, {
        error: err,
        response: undefined
      })

      fileList.splice(fileList.indexOf(file), 1)

      if (fileList.length === 0) {
        vm.showPreviewRes4FileList()
      }
    },
    showPreviewRes4FileList () {
      const vm = this
      vm.activeFileName = Object.keys(vm.resMap)[0] || ''

      const res = vm.resMap[vm.activeFileName]
      const sheetsMap = vm.getSheetsMap4Res(res)
      vm.activeSheetName = Object.keys(sheetsMap)[0] || ''

      vm.isLoading = false
    },
    getSheetsMap4Res (res) {
      return res.error ? [] : (res.response.data||res.response.body||[])
    },
    //
    indexMethod (index) {
      return index + 1
    },
    handleTabClick4File (tab) {
      const vm = this
      const res = vm.resMap[tab.name]
      const sheetsMap = vm.getSheetsMap4Res(res)
      vm.activeSheetName = Object.keys(sheetsMap)[0] || ''
    },
    handleCancel4Dialog () {
      const vm = this
      vm.promiseCb.reject(new Error('user cancled'))
      vm.dialogVisible = false
    },
    handleConfirm4Dialog () {
      const vm = this
      vm.$emit("DataImportHandleConfirm","success");
      vm.promiseCb.resolve(true)
      vm.dialogVisible = false
    },
    /**
     * 将文件列表复制一份，以避免影响父组件的上传文件列表
     */
    makeFileListReady (fileList) {
      return fileList.map(item => {
        // delete item.response;
        return {
          ...item,
          response: undefined,
          status: 'ready',
          percentage: 0
        }
      })
    },
    hasErrorMessage4File (res) {
      return (
        !!res.error ||
        !!(
          res.response.message &&
          res.response.message.indexOf('错误消息: ') > -1
        )
      )
    }
  }
}
</script>

<style scroped lang="scss">
// .com--data-import-previewer {}

.previewer-message {
  height: 6em;
  overflow: auto;
}
.el-dialog.is-fullscreen .el-dialog__body {
  height: 90%;
}
</style>

<style lang="scss">
.com--data-import-previewer-upload .el-upload--text {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/dataImport/DataImportPreviewer.vue